export interface Bonus {
  number: string;
  title: string;
  price: string;
  body: string;
  image: string;
  imageAlt: string;
}

// UNVERIFIED: confirm these 5 bonus files exist as standalone deliverables before launch, or remove this section.
export const bonuses: Bonus[] = [
  {
    number: 'BONUS 01',
    title: 'Daycare Clarity Sprint: 7-Day Startup Action Plan',
    price: '$47',
    body:
      'One decision a day for seven days, in order. What to confirm with licensing, what to buy, what to write, and what to leave alone until week two — so the week before opening stops being a blur.',
    image: 'https://cdn.magicpatterns.com/uploads/9inFDMD4baQHkoionAkgCu/daycare-bono-1.webp',
    imageAlt: 'Cover of the Daycare Clarity Sprint: 7-Day Startup Action Plan',
  },
  {
    number: 'BONUS 02',
    title: 'Parent Tour Conversion Script Pack',
    price: '$67',
    body:
      'The tour, word for word: the four questions to ask before you show a single room, the order to walk it in, and how to close on the deposit before the parent leaves the driveway.',
    image: 'https://cdn.magicpatterns.com/uploads/gswu5aAUJH5RyTfteMU8Ua/daycare-bono-2.webp',
    imageAlt: 'Cover of the Parent Tour Conversion Script Pack',
  },
  {
    number: 'BONUS 03',
    title: 'Inspection Binder Fast-Start Checklist',
    price: '$49',
    body:
      'The six tabs, in order, with every document that belongs behind each one. Print it, work down the list, and your binder passes the 60-second inspector test by the weekend.',
    image: 'https://cdn.magicpatterns.com/uploads/6uxsA1v2Tqc9YRorNVALmc/daycare-bono-3.webp',
    imageAlt: 'Cover of the Inspection Binder Fast-Start Checklist',
  },
  {
    number: 'BONUS 04',
    title: 'Daycare Pricing Confidence Worksheet',
    price: '$59',
    body:
      'Your market band, your cost floor, and where you sit between them — on one page. Fill it in and you stop guessing what to charge, and stop apologizing for the number.',
    image: 'https://cdn.magicpatterns.com/uploads/xuGmkFEPSr1VCb2pxZdryH/daycare-bono-4.webp',
    imageAlt: 'Cover of the Daycare Pricing Confidence Worksheet',
  },
  {
    number: 'BONUS 05',
    title: 'First 10 Families Outreach Kit',
    price: '$42',
    body:
      'Where the first ten families actually come from, and exactly what to send: the messages, the listings, the referral ask, and the follow-up that fills a house before you open the doors.',
    image: 'https://cdn.magicpatterns.com/uploads/qtSL6eZHvaFRWiXkKRcDiD/daycare-bono-5.webp',
    imageAlt: 'Cover of the First 10 Families Outreach Kit',
  },
];

export const bonusesIntro = {
  badge: 'INCLUDED TODAY',
  title: 'Five working tools, not five more things to read.',
  intro:
    'The volumes explain the system. These five put it to work this week. Sold separately they total $264. Today they are included.',
};
